import { IconName } from "components/atoms/Icon";
import Text from "components/atoms/Text";
import React from "react";
import { joinClassnames } from "utils/map-modifier";
import Productfeature from "../Productfeature";
import "./index.scss";

interface FilterCardProps {
  title: string | React.ReactNode;
  children?: React.ReactNode;
  tooltipIcon?: IconName;
  originalPosition?: "left" | "right";
  className?: string;
  showContent?: boolean;
  handleShowContent?: () => void;
}

const FilterCard = React.forwardRef<HTMLDivElement, FilterCardProps>(
  (
    {
      title,
      children,
      tooltipIcon,
      originalPosition,
      className,
      showContent,
      handleShowContent,
    },
    ref,
  ) => {
    const owlClass = "m-filtercard";
    return (
      <div
        ref={ref}
        className={joinClassnames(
          owlClass,
          showContent && "isShow",
          `original-${originalPosition}` || "",
          className || "",
        )}
      >
        <div className={`${owlClass}_title`} onClick={handleShowContent}>
          <Text modifiers={["uppercase"]} weight="bold">
            {title}
          </Text>
          {tooltipIcon && (
            <Productfeature
              iconName={tooltipIcon}
              className="tooltip-filter"
              description={
                "Công suất lạnh danh định ứng với nhiệt độ gió hồi 27oCDB, 19.5oCWB ; nhiệt độ ngoài trời 35oCDB. Ngoài ra, phạm vi làm lạnh hiệu quả còn tùy thuộc vào thiết kế và vị trí căn phòng nên chỉ số này chỉ mang tính chất tham khảo."
              }
            />
          )}
        </div>
        <div className={`${owlClass}_list`}>{children}</div>
      </div>
    );
  },
);

export default React.memo(FilterCard);
